
import Vue from 'vue'
import axios from "axios";
import { required } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import { DeleteReasonEntityType, DeleteReasonType, Reason, Prescriber } from '../../../types/Sapphire_dto';

extend("required", {
    ...required,
    message: "This field is required"
});

    const DeleteReasonPopup = Vue.extend({
        name: "delete-reason-popup-component",
        data: function () {
            return {
                openPopup: false,
                patID: 0,
                entityID: 0,
                deleteEntityTypeID: 0,
                entities: [],
                isBulkDelete: false,
                title: '',
                textboxNotes: '',
                labelPrimaryDisplayText: '',
                labelSecondaryDisplayText: '',
                labelSelectAReason: '',
                noReasonSelected: '',
                deleteReasons: [],
                Prescribers: [],
                selectedPrescriber: new Object() as Prescriber,
                selectedReason: new Object() as Reason,
                TheReasonType:new Object() as DeleteReasonType,
            };
        },
        mounted: function () {
            //mounted is an event in the lifecyle of a vue component
            // console.log('patientId in mounted: ' + this.patientId);    
        },
        methods: {
            canShowSaveButton() {
                var returnVal = false;
                if(this.TheReasonType === 7) {
                    if(this.selectedReason.ReasonID > 0 && this.selectedPrescriber.PrescriberID > 0)
                    returnVal = true;
                    else
                    returnVal = false;

                    return returnVal;
                }
                else if (this.selectedReason.ReasonID > 0 )
                 returnVal = true;
                return returnVal;
            },
            showPopup(patID, entityID, title, reasonType: DeleteReasonType, primaryText, secondaryText, deleteEntityTypeID: DeleteReasonEntityType) {
                this.isBulkDelete = false;
                this.title = title;
                this.entityID = entityID;
                this.patID = patID;
                this.openPopup = true;
                this.labelPrimaryDisplayText = primaryText;
                this.labelSecondaryDisplayText = secondaryText;
                this.deleteEntityTypeID = deleteEntityTypeID;
                this.selectedReason =  new Object() as Reason;
                this.selectedPrescriber =  new Object() as Prescriber;
                this.textboxNotes = '';
                this.getDeleteReasons(reasonType);
                this.getPrescribers();
                this.TheReasonType = reasonType;
            },
            showBulkPopup(patID, entities, title, reasonType: DeleteReasonType, primaryText) {
                this.isBulkDelete = true;
                this.title = title;
                this.entities = entities;
                this.patID = patID;
                this.openPopup = true;
                this.labelPrimaryDisplayText = primaryText;
                this.labelSecondaryDisplayText = '';
                this.selectedReason =  new Object() as Reason;
                this.textboxNotes = '';
                this.getDeleteReasons(reasonType);
                
            },
            hidePopup() {
                this.openPopup = false;
            },
            async getDeleteReasons(reasonType) {
                let response = await axios
                    .post("../../Common/Services/EmarClientOperations.svc/GetDeleteReasons",
                        {
                            reasonTypeID: reasonType
                        }
                )
                this.deleteReasons = [];
                this.deleteReasons = JSON.parse(response.data.d);
            },
            async getPrescribers() {
                let response = await axios
                    .post("../../Common/Services/EmarClientOperations.svc/GetPrescribers",
                        {
                           
                        }
                )
                this.Prescribers = [];
                this.Prescribers = JSON.parse(response.data.d);
            },
            async onSaveClick() {
                if (this.isBulkDelete && this.entities.length > 0) {
                    await this.entities.forEach( logItem => { 
                        if (logItem.ID > 0) {

                            let entityDeleteTypeID = DeleteReasonEntityType.DentalTreatment;

                            switch (logItem.dentalTypeID) {
                            //Waitlists
                            case 0: 
                                entityDeleteTypeID = DeleteReasonEntityType.Waitlist;
                                break;
                            //Treatments
                            case 1: 
                                entityDeleteTypeID = DeleteReasonEntityType.DentalTreatment;
                                break;
                            //Conditions
                            case 2:
                                entityDeleteTypeID = DeleteReasonEntityType.DentalCondition;
                                break;
                            }
                                                    
                            axios
                                .post("../../Common/Services/EmarClientOperations.svc/SaveDeleteReason",
                                    {
                                        patientID: this.patID,
                                        entityID: logItem.ID,
                                        deleteEntityTypeID: entityDeleteTypeID,
                                        reasonID: this.selectedReason.ReasonID,
                                        reasonNote: this.textboxNotes
                                    }
                            );
                        }
                    });
                }
                else {
                    await axios
                    .post("../../Common/Services/EmarClientOperations.svc/SaveDeleteReason",
                        {
                            patientID: this.patID,
                            entityID: this.entityID,
                            deleteEntityTypeID: this.deleteEntityTypeID,
                            reasonID: this.selectedReason.ReasonID,
                            reasonNote: this.textboxNotes
                        }
                    );
                }
                this.$emit("OnSaveClick");
                if(this.deleteEntityTypeID === DeleteReasonEntityType.Vital) {
                    this.hidePopup();
                    setTimeout("location.reload(true);", 0);
                    //this.$emit("_loadViewModel(" + this.patID + ")");
                    //console.log(window.location.href);
                }
            },        
        }
    });


    export type DeleteReasonPopupRef = InstanceType<typeof DeleteReasonPopup>;
    export default DeleteReasonPopup;

